// src/stores/useLanguage.ts

import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { LanguageDto } from "types/language.types";

interface LanguageStore {
  languages: LanguageDto[];
  currentCode: string;
  direction: "rtl" | "ltr";
  isHydrated: boolean;  // ← کلید اصلی حل مشکل
  setLanguages: (list: LanguageDto[]) => void;
  setCurrentCode: (code: string) => void;
}

function applyDirection(dir: "rtl" | "ltr") {
  document.documentElement.setAttribute("dir", dir);
  document.body.setAttribute("dir", dir);
}

export const useLanguage = create<LanguageStore>()(
  persist(
    (set, get) => ({
      languages: [],
      currentCode: "1",
      direction: "rtl",
      isHydrated: false,

      setLanguages: (list) => {
        if (get().languages.length > 0) return;
        set({ languages: list });
      },

      setCurrentCode: (code) => {
        if (get().currentCode === code) return;
        const lang = get().languages.find((l) => l.code === code);
        const direction = lang?.direction ?? "rtl";
        applyDirection(direction);
        set({ currentCode: code, direction });
      },
    }),
    {
      name: "language-storage",
      partialize: (state) => ({
        currentCode: state.currentCode,
        direction: state.direction,
        // languages رو persist نمی‌کنیم چون از API میاد
      }),
    onRehydrateStorage: () => (state) => {
  // چه state باشه چه نباشه، isHydrated رو true کن
  useLanguage.setState({ isHydrated: true });
  if (state) {
    applyDirection(state.direction);
  }
},
    }
  )
);
